import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class UnitVm {
	unitId: number;
	name?: string;
	isActiveStr?: string;
	isActive: boolean;
	fuelTypeId?: number;
	fuelTypeName?: string;
	isUpdatedOffline: boolean;
	canDelete: boolean;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'unitId': new UntypedFormControl(0, [...(validators['unitId'] ?? []), ...[Validators.required]]),
			'name': new UntypedFormControl(null, [...(validators['name'] ?? []), ...[Validators.maxLength(100), Validators.minLength(0), Validators.required]]),
			'isActiveStr': new UntypedFormControl(null, [...(validators['isActiveStr'] ?? []), ...[]]),
			'isActive': new UntypedFormControl(false, [...(validators['isActive'] ?? []), ...[]]),
			'fuelTypeId': new UntypedFormControl(null, [...(validators['fuelTypeId'] ?? []), ...[Validators.required]]),
			'fuelTypeName': new UntypedFormControl(null, [...(validators['fuelTypeName'] ?? []), ...[]]),
			'isUpdatedOffline': new UntypedFormControl(false, [...(validators['isUpdatedOffline'] ?? []), ...[]]),
			'canDelete': new UntypedFormControl(false, [...(validators['canDelete'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['name', {"orderId":0,"sortColumn":"name","searchColumn":"name","includeInExcel":true,"exportColumn":null,"displayName":"Unit Recipient Type","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['fuelTypeName', {"orderId":1,"sortColumn":"fuelTypeName","searchColumn":"fuelTypeName","includeInExcel":true,"exportColumn":null,"displayName":"Fuel Type","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['isActiveStr', {"orderId":2,"sortColumn":"isActiveStr","searchColumn":"isActiveStr","includeInExcel":true,"exportColumn":null,"displayName":"Is Active?","isVisible":false,"canSearch":true,"multiSearchCellClasses":null}],
			['canDelete', {"orderId":3,"sortColumn":"canDelete","searchColumn":"canDelete","includeInExcel":true,"exportColumn":null,"displayName":"CanDelete","isVisible":true,"canSearch":false,"multiSearchCellClasses":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): UnitVmFromFg {
		return new UnitVmFromFg(fg);
	}
}

export class UnitVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get unitId(): number {
		return this.fg.get('unitId').value;
	}
	set unitId(val) {
		this.fg.get('unitId').setValue(val);
	}

	get name(): string {
		return this.fg.get('name').value;
	}
	set name(val) {
		this.fg.get('name').setValue(val);
	}

	get isActiveStr(): string {
		return this.fg.get('isActiveStr').value;
	}
	set isActiveStr(val) {
		this.fg.get('isActiveStr').setValue(val);
	}

	get isActive(): boolean {
		return this.fg.get('isActive').value;
	}
	set isActive(val) {
		this.fg.get('isActive').setValue(val);
	}

	get fuelTypeId(): number {
		return this.fg.get('fuelTypeId').value;
	}
	set fuelTypeId(val) {
		this.fg.get('fuelTypeId').setValue(val);
	}

	get fuelTypeName(): string {
		return this.fg.get('fuelTypeName').value;
	}
	set fuelTypeName(val) {
		this.fg.get('fuelTypeName').setValue(val);
	}

	get isUpdatedOffline(): boolean {
		return this.fg.get('isUpdatedOffline').value;
	}
	set isUpdatedOffline(val) {
		this.fg.get('isUpdatedOffline').setValue(val);
	}

	get canDelete(): boolean {
		return this.fg.get('canDelete').value;
	}
	set canDelete(val) {
		this.fg.get('canDelete').setValue(val);
	}
}
